// Utils
import { randomize } from '../data/utils'
import { flatten } from 'lodash'
/////////////////////////////////////
//////////// SPANISH TEXT ////////////
/////////////////////////////////////
/////////////// Antrhopo ///////////////
const anthrIntrEs = {
  id: 'ant',
  message: 'Primero, vamos a imaginar que esta marca puede ser una persona 😎',
  qGlobId: 'ant',
  globId: 'a',
}
const antrhopoEsBef = [
  // Welcome Mesage
  // Moral Virtue
  {
    idq: 'antVir1Q',
    question: '¿Para tí esta marca es confiable?',
    idAns: 'antVir1',
    idVal: 'antVir1Val',
    qGlobId: 'ant',
    globId: 'a',
  },
  {
    idq: 'antVir2Q',
    question: '¿Esta marca tiene principios / valores?',
    idAns: 'antVir2',
    idVal: 'antVir2Val',
    qGlobId: 'ant',
    globId: 'a',
  },
  {
    idq: 'antVir3Q',
    question: '¿Esta marca es honesta?',
    idAns: 'antVir3',
    idVal: 'antVir3Val',
    qGlobId: 'ant',
    globId: 'a',
  },
  // Experience
  {
    idq: 'antExp1Q',
    question: '¿Esta marca está en condiciones de reflexionar?',
    idAns: 'antExp1',
    idVal: 'antExp1Val',
    qGlobId: 'ant',
    globId: 'a',
  },
  {
    idq: 'antExp2Q',
    question: '¿Consideras que esta marca puede imaginar cosas por sí misma?',
    idAns: 'antExp2',
    idVal: 'antExp2Val',
    qGlobId: 'ant',
    globId: 'a',
  },
  {
    idq: 'antExp3Q',
    question: '¿Es posible que esta marca tenga la capacidad de razonar?',
    idAns: 'antExp3',
    idVal: 'antExp3Val',
    qGlobId: 'ant',
    globId: 'a',
  },

  // Emotionality
  {
    idq: 'antEmo1Q',
    question:
      '¿La marca puede experimentar remordimientos por aquellas acciones que ésta considera vergonzosas?',
    idAns: 'antEmo1',
    idVal: 'antEmo1Val',
    qGlobId: 'ant',
    globId: 'a',
  },
  {
    idq: 'antEmo2Q',
    question:
      '¿Crees que la marca puede sentir culpa cuando hiere a alguien con su comportamiento?',
    idAns: 'antEmo2',
    idVal: 'antEmo2Val',
    qGlobId: 'ant',
    globId: 'a',
  },
  {
    idq: 'antEmo3Q',
    question:
      'Es posible que la marca pueda sentir vergüenza cuando la gente tiene opiniones y juicios negativos sobre ella?',
    idAns: 'antEmo3',
    idVal: 'antEmo3Val',
    qGlobId: 'ant',
    globId: 'a',
  },
]
//// EXPORT ANTHROPOMORPH RANDOMIZED /////////
export const antrhopoEs = flatten([...[anthrIntrEs], randomize(antrhopoEsBef)])
//// END  ANTHROPOMORPH RANDOMIZED /////////

/////////////// Social Distance ///////////////
const socIntrEs =
  // Welcome Mesage
  {
    id: 'socDi',
    message:
      'Excelente!, Ahora imagina que marca es alguien que conoces muy bien 😎, quisiera saber qué tipo de relación percibes con ella.',
    qGlobId: 'socDi',
    globId: 's',
  }
const socialDisEsBef = [
  // Other in Self
  {
    img: 'ois',
    idq: 'socDiOis1Q',
    question:
      'Selecciona la imagen que mejor representa tu relación con la marca',
    idAns: 'socDiOis1',
    idVal: 'socDiOis1Val',
    qGlobId: 'socDi',
    globId: 's',
  },
  // Social Proximity
  {
    idq: 'socDiProx1Q',
    question:
      'En general, ¿en qué medida percibes que la marca se asemeja a tí?',
    idAns: 'socDiProx1',
    idVal: 'socDiProx1Val',
    qGlobId: 'socDi',
    globId: 's',
  },
  {
    idq: 'socDiProx2Q',
    question:
      '¿En qué medida sientes que la marca es cercana a tí (por ejemplo, socialmente cercanos)?',
    idAns: 'socDiProx2',
    idVal: 'socDiProx2Val',
    qGlobId: 'socDi',
    globId: 's',
  },
]

//// EXPORT SOCIAL DISTANCE RANDOMIZED /////////
export const socialDisEs = flatten([...[socIntrEs], randomize(socialDisEsBef)])
//// END  SOCIAL DISTANCE RANDOMIZED /////////

/////////////// BRAND LOVE ///////////////
const brndLvIntrEs =
  // Welcome Mesage
  {
    id: 'brLv',
    message: 'Ahora hablemos de amor!! ❤️❤️',
    qGlobId: 'brLv',
    globId: 'bl',
  }
const brandLoveEsBef = [
  // Self-brand integration
  {
    idq: 'brLvSelf1Q',
    question:
      '¿Usar la marca dice algo "verdadero" y "profundo" sobre quién eres como persona?',
    idAns: 'brLvSelf1',
    idVal: 'brLv1SelfVal',
    qGlobId: 'brLv',
    globId: 'bl',
  },
  // Passion-driven behaviors
  {
    idq: 'brLvPassi1Q',
    question:
      'Utilizando los productos de esta marca: ¿En qué medida te sientes tú mismo?',
    idAns: 'brLvPassi1',
    idVal: 'brLvPassi1Val',
    qGlobId: 'brLv',
    globId: 'bl',
  },
  // Emotional attachment
  {
    idq: 'brLv1AttachQ',
    question: '¿Te sientes emocionalmente conectado con la marca?',
    idAns: 'brLvAttach1',
    idVal: 'brLvAttach1Val',
    qGlobId: 'brLv',
    globId: 'bl',
  },
  //Long-term relationship
  {
    idq: 'brLvLoTe1Q',
    question:
      '¿Hasta qué punto consideras que usarás la marca durante mucho tiempo?',
    idAns: 'brLvLoTe1',
    idVal: 'brLvLoTe1Val',
    qGlobId: 'brLv',
    globId: 'bl',
  },
  // Anticipated separation distress
  {
    idq: 'brLvSepar1Q',
    question:
      'Supongamos que la marca deja de existir, ¿en qué medida sentirías ansiedad? 😰',
    idAns: 'brLvSepar1',
    idVal: 'brLvSepar1Val',
    qGlobId: 'brLv',
    globId: 'bl',
  },
  // Attitude valence
  {
    idq: 'brLvVale1Q',
    question:
      'A continuación, expresa tus sentimientos y evaluación general sobre la marca (👎 1 negativo - 6 positivo 👍)',
    idAns: 'brLvVale1',
    idVal: 'brLvVale1Val',
    qGlobId: 'brLv',
    globId: 'bl',
  },
]

//// EXPORT BRAND LOVE RANDOMIZED /////////
export const brandLoveEs = flatten([
  ...[brndLvIntrEs],
  randomize(brandLoveEsBef),
])
//// END  BRAND LOVE RANDOMIZED /////////

/////////////// HOT & COLD BRQ ///////////////
const brqIntrEs =
  // Welcome Mesage
  {
    id: 'brq',
    message: 'Listo, Vamos al siguiente tema! ⭐',
    qGlobId: 'brq',
    globId: 'br',
  }
// // Option Continue
// {
//   id: 'followBrq',
//   message: 'Te parece si seguimos con la próxima?',
//   trigger: 'nextOpt',
// },
// {
//   id: 'nextOpt',
//   options: [
//     { value: 'si', label: 'Si 👍', trigger: '5brq' },
//     // { value: 'no', label: 'No 👎', trigger: 'noContinue' },
//   ],
// },
// // NO, Save and continue after
// {
//   id: 'noContinue',
//   message:
//     'No te preocupes, puedes continuar más tarde si quieres 🙂, Haz click en guardar para continuar después desde acá',
//   trigger: 'saveInfo',
// },
// {
//   id: 'saveInfo',
//   saveInfo: true,
// }
const brqEsBef = [
  // Cold BRQ
  // Satisfaction
  {
    idq: 'brqSat1Q',
    question: 'Siempre estoy satisfecho con mi decisión de usar la marca',
    idAns: 'brqSat1',
    idVal: 'brqSat1Val',
    qGlobId: 'brq',
    globId: 'br',
  },
  {
    idq: 'brqSat2Q',
    question: 'Estoy completamente satisfecho con la marca',
    idAns: 'brqSat2',
    idVal: 'brqSat2Val',
    qGlobId: 'brq',
    globId: 'br',
  },
  {
    idq: 'brqSat3Q',
    question:
      'La marca ofrece exactamente lo que espero cuando compro este tipo de productos',
    idAns: 'brqSAt3',
    idVal: 'brqSat3Val',
    qGlobId: 'brq',
    globId: 'br',
  },
  // Brand trust
  {
    idq: 'brqTru1Q',
    question: 'Confío en esta marca',
    idAns: 'brqTru1',
    idVal: 'brqTru1Val',
    qGlobId: 'brq',
    globId: 'br',
  },
  {
    idq: 'brqTru2Q',
    question: 'Esta es una marca honesta',
    idAns: 'brqTru2',
    idVal: 'brqTru2Val',
    qGlobId: 'brq',
    globId: 'br',
  },
  {
    idq: 'brqTru3Q',
    question: '¿Consideras que es una marca segura?',
    idAns: 'brqTru3',
    idVal: 'brqTru3Val',
    qGlobId: 'brq',
    globId: 'br',
  },
  // Hot BRQ
  // Commitment
  {
    idq: 'brqCommit1Q',
    question: 'Sientes que eres fiel a la marca',
    idAns: 'brqCommit1',
    idVal: 'brqCommit1Val',
    qGlobId: 'brq',
    globId: 'br',
  },
  {
    idq: 'brqCommit2Q',
    question: 'Esta marca puede contar conmigo en todo momento',
    idAns: 'brqCommit2',
    idVal: 'brqCommit2Val',
    qGlobId: 'brq',
    globId: 'br',
  },
  {
    idq: 'brqCommit3Q',
    question: 'Me quedaré con esta marca en las buenas y las malas',
    idAns: 'brqCommit3',
    idVal: 'brqCommit3Val',
    qGlobId: 'brq',
    globId: 'br',
  },
  // Intimacy
  {
    idq: 'brqInti1Q',
    question:
      'Comparado con otras, me siento mucho más identificado con esta marca',
    idAns: 'brqInti1',
    idVal: 'brqInti1Val',
    qGlobId: 'brq',
    globId: 'br',
  },
  {
    idq: 'brqInti2Q',
    question: 'Me siento emocionalmente conectado con esta marca',
    idAns: 'brqInti2',
    idVal: 'brqInti2Val',
    qGlobId: 'brq',
    globId: 'br',
  },
  // Passion
  {
    idq: 'brqPassi1Q',
    question: 'Hay momentos en los que realmente anhelo usar esta marca',
    idAns: 'brqPassi1',
    idVal: 'brqPassi1Val',
    qGlobId: 'brq',
    globId: 'br',
  },
  {
    idq: 'brqPassi2Q',
    question:
      'Siento que algo me falta cuando no uso la marca durante un largo tiempo',
    idAns: 'brqPassi2',
    idVal: 'brqPassi2Val',
    qGlobId: 'brq',
    globId: 'br',
  },
]

//// EXPORT BRQ RANDOMIZED /////////
export const brqEs = flatten([...[brqIntrEs], randomize(brqEsBef)])
//// END  BRQ RANDOMIZED /////////

/////////////// CHATBOT AFFECTIVE & COGNITIVE EXPERIENCE ///////////////
const botCxIntEs =
  // Welcome Mesage
  [
    {
      id: 'chatExp',
      message:
        'Ahora hablemos de la experiencia que tuviste con el chatbot que viste ayudando a comprar productos de la marca! 🤖🤖',
      qGlobId: 'chatExp',
      globId: 'cb',
    },
    {
      id: 'chatExp',
      message:
        'Quisiera que imaginaras que eres la persona que hace la compra del video anterior',
      qGlobId: 'chatExp',
      globId: 'cb',
    },
  ]
// {
//   id: 'chatExp',
//   message: 'Genial!, ya casi terminamos!',
//   trigger: 'prepare',
// },

const chatExpEsBef = [
  // Functional Congruency
  //// Perceived Helpfulness
  {
    idq: 'chatExpFunCongrHelp1Q',
    question: '¿El uso del chatbot ha sido oportuno?',
    idAns: 'chatExpFunCongrHelp1',
    idVal: 'chatExpFunCongrHelp1Val',
    qGlobId: 'chatExp',
    globId: 'cb',
  },
  {
    idq: 'chatExpFunCongrHelp3Q',
    question: '¿El chatbot te ha brindado la información necesaria?',
    idAns: 'chatExpFunCongrHelp3',
    idVal: 'chatExpFunCongrHelp3Val',
    qGlobId: 'chatExp',
    globId: 'cb',
  },
  {
    idq: 'chatExpFunCongrHelp2Q',
    question:
      'Si la compra fuera real ¿Qué tan positivo sería el impacto de usar el chatbot en tu decisión de compra?',
    idAns: 'chatExpFunCongrHelp2',
    idVal: 'chatExpFunCongrHelp2Val',
    qGlobId: 'chatExp',
    globId: 'cb',
  },
  //// Perceived usefulness
  {
    idq: 'chatExpFunCongrUse1Q',
    question:
      '¿El chatbot es útil para la compra de los productos de la marca?',
    idAns: 'chatExpFunCongrUse1',
    idVal: 'chatExpFunCongrUse1Val',
    qGlobId: 'chatExp',
    globId: 'cb',
  },
  {
    idq: 'chatExpFunCongrUse2Q',
    question:
      '¿Crees que el chatbot mejora tu eficiencia en el proceso de búsqueda y compra?',
    idAns: 'chatExpFunCongrUse2',
    idVal: 'chatExpFunCongrUse2Val',
    qGlobId: 'chatExp',
    globId: 'cb',
  },
  {
    idq: 'chatExpFunCongrUse3Q',
    question: '¿El chatbot te permite buscar y comprar más rápido?',
    idAns: 'chatExpFunCongrUse3',
    idVal: 'chatExpFunCongrUse3Val',
    qGlobId: 'chatExp',
    globId: 'cb',
  },
  // {
  //   idq: 'chatExpFunCongrUse4Q',
  //   question: '¿El chatbot hace más fácil tu compra?',
  //   idAns: 'chatExpFunCongrUse4',
  //   idVal: 'chatExpFunCongrUse4Val',
  //   qGlobId: 'chatExp',
  //   globId: 'cb',
  // },
  // Brand congruency
  {
    idq: 'chatExpBrandCong1Q',
    question:
      '¿En qué medida el chatbot se adapta a la percepción que tienes de la marca?',
    idAns: 'chatExpBrandCong1',
    idVal: 'chatExpBrandCong1Val',
    qGlobId: 'chatExp',
    globId: 'cb',
  },
  {
    idq: 'chatExpBrandCong2Q',
    question:
      '¿El comportamiento del chatbot es lógico con la percepción que tienes de la marca?',
    idAns: 'chatExpBrandCong2',
    idVal: 'chatExpBrandCong2Val',
    qGlobId: 'chatExp',
    globId: 'cb',
  },
  {
    idq: 'chatExpBrandCong3Q',
    question: '¿El chatbot es apropiado para la marca?',
    idAns: 'chatExpBrandCong3',
    idVal: 'chatExpBrandCong3Val',
    qGlobId: 'chatExp',
    globId: 'cb',
  },
  // Hedonic Value
  {
    idq: 'chatExpHedo1Q',
    question: '¿Qué tan amena te resultó La interacción con el chatbot?',
    idAns: 'chatExpHedo1',
    idVal: 'chatExpHedo1Val',
    qGlobId: 'chatExp',
    globId: 'cb',
  },
  {
    idq: 'chatExpHedo2Q',
    question: '¿La interacción con el chatbot te ha parecido emocionante?',
    idAns: 'chatExpHedo2',
    idVal: 'chatExpHedo2Val',
    qGlobId: 'chatExp',
    globId: 'cb',
  },
  {
    idq: 'chatExpHedo3Q',
    question: '¿La interacción con el chatbot te pareció agradable?',
    idAns: 'chatExpHedo3',
    idVal: 'chatExpHedo3Val',
    qGlobId: 'chatExp',
    globId: 'cb',
  },
  // {
  //   idq: 'chatExpHedo4Q',
  //   question: '¿Te resultó interesante la interacción con el chatbot?',
  //   idAns: 'chatExpHedo4',
  //   idVal: 'chatExpHedo4Val',
  //   qGlobId: 'chatExp',
  //   globId: 'cb',
  // },
  // {
  //   idq: 'chatExpHedo5Q',
  //   question: 'Te parece divertido interactuar con el chatbot?',
  //   idAns: 'chatExpHedo5',
  //   idVal: 'chatExpHedo5Val',
  //   qGlobId: 'chatExp',
  //   globId: 'cb',
  // },
  // Social Congruency
  {
    idq: 'chatExpSocCong1Q',
    question:
      '¿Al interactuar con el chatbot ¿tuviste una sensación de contacto humano?',
    idAns: 'chatExpSocCong1',
    idVal: 'chatExpSocCong1Val',
    qGlobId: 'chatExp',
    globId: 'cb',
  },
  {
    idq: 'chatExpSocCong2Q',
    question:
      'En tu opinion, aunque no puedes ver al chatbot en la vida real ¿sentiste calidez humana?',
    idAns: 'chatExpSocCong2',
    idVal: 'chatExpSocCong2Val',
    qGlobId: 'chatExp',
    globId: 'cb',
  },
  // {
  //   idq: 'chatExpSocCong3Q',
  //   question: 'Hablando con el chatbot ¿tuviste la sensación de sociabilidad?',
  //   idAns: 'chatExpSocCong3',
  //   idVal: 'chatExpSocCong3Val',
  //   qGlobId: 'chatExp',
  //   globId: 'cb',
  // },
  {
    idq: 'chatExpSocCong4Q',
    question: '¿Sentiste que se trata una persona que inspira confianza?',
    idAns: 'chatExpSocCong4',
    idVal: 'chatExpSocCong4Val',
    qGlobId: 'chatExp',
    globId: 'cb',
  },
  // Branded chatbot experience
  {
    idq: 'chatBrandExp1Q',
    question: '¿El diseño y el lenguaje del chatbot fueron agradables?',
    idAns: 'chatBrandExp1',
    idVal: 'chatBrandExp1Val',
    qGlobId: 'chatExp',
    globId: 'cb',
  },
  // {
  //   idq: 'chatBrandExp2Q',
  //   question: '¿El chatbot te pareció fácil de usar?',
  //   idAns: 'chatBrandExp2',
  //   idVal: 'chatBrandExp2Val',
  //   qGlobId: 'chatExp',
  //   globId: 'cb',
  // },
  {
    idq: 'chatBrandExp3Q',
    question: '¿Sientes que el chatbot siempre responde con prontitud?',
    idAns: 'chatBrandExp3',
    idVal: 'chatBrandExp3Val',
    qGlobId: 'chatExp',
    globId: 'cb',
  },
  // {
  //   idq: 'chatBrandExp4Q',
  //   question: '¿Las respuestas del chatbot son siempre actualizadas?',
  //   idAns: 'chatBrandExp4',
  //   idVal: 'chatBrandExp4Val',
  //   qGlobId: 'chatExp',
  //   globId: 'cb',
  // },
  {
    idq: 'chatBrandExp5Q',
    question: '¿El chatbot siempre ofrece información precisa?',
    idAns: 'chatBrandExp5',
    idVal: 'chatBrandExp5Val',
    qGlobId: 'chatExp',
    globId: 'cb',
  },
  // Patronage Intention
  {
    idq: 'chatPatrong1Q',
    question:
      '¿Estarías dispuesto a hacer compras con la ayuda de este chatbot?',
    idAns: 'chatPatrong1',
    idVal: 'chatPatrong1Val',
    qGlobId: 'chatExp',
    globId: 'cb',
  },
  {
    idq: 'chatPatrong2Q',
    question:
      '¿La probabilidad de que compres usando este chatbot es muy alta?',
    idAns: 'chatPatrong2',
    idVal: 'chatPatrong2Val',
    qGlobId: 'chatExp',
    globId: 'cb',
  },
  {
    idq: 'chatPatrong3Q',
    question: '¿Estarías dispuesto a recomendar este chatbot a tus amigos?',
    idAns: 'chatPatrong3',
    idVal: 'chatPatrong3Val',
    qGlobId: 'chatExp',
    globId: 'cb',
  },
]
//// EXPORT CHATBOT CX RANDOMIZED /////////
export const chatExpEs = flatten([...botCxIntEs, randomize(chatExpEsBef)])
//// END  BRQ RANDOMIZED /////////

/////////////// Ideal Variable Color Blue ///////////////
// Welcome Mesage
const colBluIntrEs = [
  {
    id: 'colBlu',
    message: 'Permíteme conocer tus gustos acerca del color azul! 💧',
    qGlobId: 'colBlu',
    globId: 'blu',
  },
]
const colBlueEsBef = [
  {
    idq: 'col1Blu',
    question: 'Prefieres el color azul a otros colores',
    idAns: 'col1Blu',
    idVal: 'col1Blu',
    qGlobId: 'colBlu',
    globId: 'blu',
  },
  {
    idq: 'col2Blu',
    question: 'Te gusta el color azul',
    idAns: 'col2Blu',
    idVal: 'col2Blu',
    qGlobId: 'colBlu',
    globId: 'blu',
  },
  {
    idq: 'col3Blu',
    question: 'Te gustan las prendas de color azul',
    idAns: 'col3Blu',
    idVal: 'col3Blu',
    qGlobId: 'colBlu',
    globId: 'blu',
  },
  {
    idq: 'col4Blu',
    question: 'Te gusta la pintura azul',
    idAns: 'col4Blu',
    idVal: 'col4Blu',
    qGlobId: 'colBlu',
    globId: 'blu',
  },
]
//// EXPORT COLOR BLUE RANDOMIZED /////////
export const colBluEs = flatten([...colBluIntrEs, randomize(colBlueEsBef)])
//// END  COLOR BLUE /////////

/////////////////////////////////////
//////////// FRENCH TEXT ////////////
/////////////////////////////////////
/////////////// Antrhopo ///////////////
const anthrIntrFr = {
  id: 'ant',
  message:
    "Tout d'abord, imaginons que cette marque peut être un individu (une personne) 😎.",
  qGlobId: 'ant',
  globId: 'a',
}
const antrhopoFrBef = [
  // Welcome Mesage
  // Moral Virtue
  {
    idq: 'antVir1Q',
    question: 'La marque est-elle digne de confiance ?',
    idAns: 'antVir1',
    idVal: 'antVir1Val',
    qGlobId: 'ant',
    globId: 'a',
  },
  {
    idq: 'antVir2Q',
    question: 'La marque est guidée par des principes ?',
    idAns: 'antVir2',
    idVal: 'antVir2Val',
    qGlobId: 'ant',
    globId: 'a',
  },
  {
    idq: 'antVir3Q',
    question: 'Cette marque est sincère?',
    idAns: 'antVir3',
    idVal: 'antVir3Val',
    qGlobId: 'ant',
    globId: 'a',
  },
  // Experience
  {
    idq: 'antExp1Q',
    question: 'Cette marque est capable de réfléchir ?',
    idAns: 'antExp1',
    idVal: 'antExp1Val',
    qGlobId: 'ant',
    globId: 'a',
  },
  {
    idq: 'antExp2Q',
    question:
      'Penses-tu que cette marque peut imaginer des choses par elle-même ?',
    idAns: 'antExp2',
    idVal: 'antExp2Val',
    qGlobId: 'ant',
    globId: 'a',
  },
  {
    idq: 'antExp3Q',
    question: 'Est-ce possible que cette marque ait la capacité de raisonner ?',
    idAns: 'antExp3',
    idVal: 'antExp3Val',
    qGlobId: 'ant',
    globId: 'a',
  },

  // Emotionality
  {
    idq: 'antEmo1Q',
    question:
      "La marque peut-elle éprouver des remords pour des actions qu'elle considère comme honteuses ?",
    idAns: 'antEmo1',
    idVal: 'antEmo1Val',
    qGlobId: 'ant',
    globId: 'a',
  },
  {
    idq: 'antEmo2Q',
    question:
      "Penses-tu que la marque est capable de se sentir responsable lorsqu'elle blesse quelqu'un par son comportement ?",
    idAns: 'antEmo2',
    idVal: 'antEmo2Val',
    qGlobId: 'ant',
    globId: 'a',
  },
  {
    idq: 'antEmo3Q',
    question:
      'Est-il possible que la marque éprouve de la gêne lorsque les gens expriment des opinions et des jugements négatifs à son égard ?',
    idAns: 'antEmo3',
    idVal: 'antEmo3Val',
    qGlobId: 'ant',
    globId: 'a',
  },
]
//// EXPORT ANTHROPOMORPH RANDOMIZED /////////
export const antrhopoFr = flatten([...[anthrIntrFr], randomize(antrhopoFrBef)])
//// END  ANTHROPOMORPH RANDOMIZED /////////

/////////////// Social Distance ///////////////
const socIntrFr =
  // Welcome Mesage
  {
    id: 'socDi',
    message:
      "Excellent!, Maintenant, suppose que la marque est quelqu'un que tu connais très bien 😎, j'aimerais comprendre quel type de relation tu considères avoir avec celle-ci.",
    qGlobId: 'socDi',
    globId: 's',
  }
const socialDisFrBef = [
  // Other in Self
  {
    img: 'oisfr',
    idq: 'socDiOis1Q',
    question: 'Quelle image représente le mieux ta relation à cette marque ?',
    idAns: 'socDiOis1',
    idVal: 'socDiOis1Val',
    qGlobId: 'socDi',
    globId: 's',
  },
  // Social Proximity
  {
    idq: 'socDiProx1Q',
    question:
      'En général, dans quelle mesure penses-tu que la marque te ressemble ?',
    idAns: 'socDiProx1',
    idVal: 'socDiProx1Val',
    qGlobId: 'socDi',
    globId: 's',
  },
  {
    idq: 'socDiProx2Q',
    question:
      "Dans quelle mesure la marque est-t-elle proche de toi (c'est-à-dire socialement proche) ?",
    idAns: 'socDiProx2',
    idVal: 'socDiProx2Val',
    qGlobId: 'socDi',
    globId: 's',
  },
]
//// EXPORT SOCIAL DISTANCE RANDOMIZED /////////
export const socialDisFr = flatten([...[socIntrFr], randomize(socialDisFrBef)])
//// END  SOCIAL DISTANCE RANDOMIZED /////////

/////////////// BRAND LOVE ///////////////
const brndLvIntrFr =
  // Welcome Mesage
  {
    id: 'brLv',
    message: "Parlons maintenant d'amour ! ❤️❤️",
    qGlobId: 'brLv',
    globId: 'bl',
  }
const brandLoveFrBef = [
  // Self-brand integration
  {
    idq: 'brLvSelf1Q',
    question:
      'L\'utilisation de la marque dit-elle quelque chose de "vrai" et de "profond" sur qui tu es en tant qu\'individu ?',
    idAns: 'brLvSelf1',
    idVal: 'brLv1SelfVal',
    qGlobId: 'brLv',
    globId: 'bl',
  },
  // Passion-driven behaviors
  {
    idq: 'brLvPassi1Q',
    question:
      'En utilisant les produits de cette marque : Dans quelle mesure te sens-tu toi-même ?',
    idAns: 'brLvPassi1',
    idVal: 'brLvPassi1Val',
    qGlobId: 'brLv',
    globId: 'bl',
  },
  // Emotional attachment
  {
    idq: 'brLv1AttachQ',
    question: 'Te sens-tu émotionnellement lié à cette marque ?',
    idAns: 'brLvAttach1',
    idVal: 'brLvAttach1Val',
    qGlobId: 'brLv',
    globId: 'bl',
  },
  //Long-term relationship
  {
    idq: 'brLvLoTe1Q',
    question:
      'Dans quelle mesure penses-tu continuer à utiliser la marque à long terme ?',
    idAns: 'brLvLoTe1',
    idVal: 'brLvLoTe1Val',
    qGlobId: 'brLv',
    globId: 'bl',
  },
  // Anticipated separation distress
  {
    idq: 'brLvSepar1Q',
    question:
      'Imaginons que la marque disparaisse, à quel point serais-tu anxieux ? 😰',
    idAns: 'brLvSepar1',
    idVal: 'brLvSepar1Val',
    qGlobId: 'brLv',
    globId: 'bl',
  },
  // Attitude valence
  {
    idq: 'brLvVale1Q',
    question:
      'Globalement, quels sont tes sentiments et évaluation vis-à-vis de la marque (👎 1 négatif - 6 positif 👍).',
    idAns: 'brLvVale1',
    idVal: 'brLvVale1Val',
    qGlobId: 'brLv',
    globId: 'bl',
  },
]
//// EXPORT BRAND LOVE RANDOMIZED /////////
export const brandLoveFr = flatten([
  ...[brndLvIntrFr],
  randomize(brandLoveFrBef),
])
//// END  BRAND LOVE RANDOMIZED /////////

/////////////// HOT & COLD BRQ ///////////////
const brqIntrFr =
  // Welcome Mesage
  {
    id: 'brq',
    message: 'On passe au sujet suivant ! ⭐',
    qGlobId: 'brq',
    globId: 'br',
  }
// // Option Continue
// {
//   id: 'followBrq',
//   message: 'On passe à la suivante ?',
//   trigger: 'nextOpt',
// },
// {
//   id: 'nextOpt',
//   options: [
//     { value: 'si', label: 'Oui 👍', trigger: '5brq' },
//     // { value: 'no', label: 'Non 👎', trigger: 'noContinue' },
//   ],
// },
// // NO, Save and continue after
// {
//   id: 'noContinue',
//   message:
//     'Ne t\'inquiète pas, tu peux continuer plus tard si tu veux 🙂 clique sur "enregistrer pour continuer plus tard à partir de ce point',
//   trigger: 'saveInfo',
// },
// {
//   id: 'saveInfo',
//   saveInfo: true,
// },

const brqFrBef = [
  // Cold BRQ
  // Satisfaction
  {
    idq: 'brqSat1Q',
    question: "Es-tu toujours satisfait de ton choix d'utiliser la marque ?",
    idAns: 'brqSat1',
    idVal: 'brqSat1Val',
    qGlobId: 'brq',
    globId: 'br',
  },
  {
    idq: 'brqSat2Q',
    question: 'Es-tu entièrement satisfait de la marque ?',
    idAns: 'brqSat2',
    idVal: 'brqSat2Val',
    qGlobId: 'brq',
    globId: 'br',
  },
  {
    idq: 'brqSat3Q',
    question:
      'La marque offre-t-elle exactement ce que tu attends lorsque tu achètes ce genre de produits ?',
    idAns: 'brqSAt3',
    idVal: 'brqSat3Val',
    qGlobId: 'brq',
    globId: 'br',
  },
  // Brand trust
  {
    idq: 'brqTru1Q',
    question: 'Fais-tu confiance à cette marque ?',
    idAns: 'brqTru1',
    idVal: 'brqTru1Val',
    qGlobId: 'brq',
    globId: 'br',
  },
  {
    idq: 'brqTru2Q',
    question: "Pour toi, il s'agit d'une marque honnête ?",
    idAns: 'brqTru2',
    idVal: 'brqTru2Val',
    qGlobId: 'brq',
    globId: 'br',
  },
  {
    idq: 'brqTru3Q',
    question: "Penses-tu que c'est une marque fiable ?",
    idAns: 'brqTru3',
    idVal: 'brqTru3Val',
    qGlobId: 'brq',
    globId: 'br',
  },
  // Hot BRQ
  // Commitment
  {
    idq: 'brqCommit1Q',
    question: 'Penses-tu être fidèle à cette marque ?',
    idAns: 'brqCommit1',
    idVal: 'brqCommit1Val',
    qGlobId: 'brq',
    globId: 'br',
  },
  {
    idq: 'brqCommit2Q',
    question: 'Cette marque peut compter sur toi à tout moment ?',
    idAns: 'brqCommit2',
    idVal: 'brqCommit2Val',
    qGlobId: 'brq',
    globId: 'br',
  },
  {
    idq: 'brqCommit3Q',
    question: 'tu resteras avec cette marque contre vents et marées ?',
    idAns: 'brqCommit3',
    idVal: 'brqCommit3Val',
    qGlobId: 'brq',
    globId: 'br',
  },
  // Intimacy
  {
    idq: 'brqInti1Q',
    question:
      "Par rapport à d'autres marques, est-ce que tu t’identifies beaucoup plus à cette marque ?",
    idAns: 'brqInti1',
    idVal: 'brqInti1Val',
    qGlobId: 'brq',
    globId: 'br',
  },
  {
    idq: 'brqInti2Q',
    question: 'Tu te sens émotionnellement lié à cette marque ?',
    idAns: 'brqInti2',
    idVal: 'brqInti2Val',
    qGlobId: 'brq',
    globId: 'br',
  },
  // Passion
  {
    idq: 'brqPassi1Q',
    question:
      "Y a-t-il des moments où tu as vraiment envie d'utiliser cette marque ?",
    idAns: 'brqPassi1',
    idVal: 'brqPassi1Val',
    qGlobId: 'brq',
    globId: 'br',
  },
  {
    idq: 'brqPassi2Q',
    question:
      "Sens-tu qu'il manque quelque chose lorsque tu n'utilises pas la marque durant un certain temps ?",
    idAns: 'brqPassi2',
    idVal: 'brqPassi2Val',
    qGlobId: 'brq',
    globId: 'br',
  },
]
//// EXPORT BRQ RANDOMIZED /////////
export const brqFr = flatten([...[brqIntrFr], randomize(brqFrBef)])
//// END  BRQ RANDOMIZED /////////

/////////////// CHATBOT AFFECTIVE & COGNITIVE EXPERIENCE ///////////////
const botCxIntFr =
  // Welcome Mesage
  [
    {
      id: 'chatExp',
      message:
        "Parlons maintenant de l'expérience que tu as vécue avec le chatbot qui a assisté dans l'achat de produits de marque dans la vidéo ! 🤖🤖",
      qGlobId: 'chatExp',
      globId: 'cb',
    },
    {
      id: 'chatExp',
      message:
        "Je vous propose d'imaginer que vous êtes la personne qui effectue l'achat dans la vidéo précédente.",
      qGlobId: 'chatExp',
      globId: 'cb',
    },
  ]
// {
//   id: 'chatExp',
//   message: 'Super, on y est presque !',
//   trigger: 'prepare',
// },
const chatExpFrBef = [
  // Functional Congruency
  //// Perceived Helpfulness
  {
    idq: 'chatExpFunCongrHelp1Q',
    question: "L'utilisation du chatbot était-elle appropriée ?",
    idAns: 'chatExpFunCongrHelp1',
    idVal: 'chatExpFunCongrHelp1Val',
    qGlobId: 'chatExp',
    globId: 'cb',
  },
  {
    idq: 'chatExpFunCongrHelp3Q',
    question:
      'Dans la vidéo, le chatbot a-t-il fourni les informations nécessaires ?',
    idAns: 'chatExpFunCongrHelp3',
    idVal: 'chatExpFunCongrHelp3Val',
    qGlobId: 'chatExp',
    globId: 'cb',
  },
  {
    idq: 'chatExpFunCongrHelp2Q',
    question:
      "Si l'achat était réel, quel aurait été l'impact positif de l'utilisation du chatbot sur la décision d'achat ?",
    idAns: 'chatExpFunCongrHelp2',
    idVal: 'chatExpFunCongrHelp2Val',
    qGlobId: 'chatExp',
    globId: 'cb',
  },
  //// Perceived usefulness
  {
    idq: 'chatExpFunCongrUse1Q',
    question:
      "Le chatbot de la vidéo est-il utile à l'achat des produits de la marque ?",
    idAns: 'chatExpFunCongrUse1',
    idVal: 'chatExpFunCongrUse1Val',
    qGlobId: 'chatExp',
    globId: 'cb',
  },
  {
    idq: 'chatExpFunCongrUse2Q',
    question:
      "Penses-tu que les chatbots contribuent à améliorer ton efficacité dans le processus de recherche et d'achat ?",
    idAns: 'chatExpFunCongrUse2',
    idVal: 'chatExpFunCongrUse2Val',
    qGlobId: 'chatExp',
    globId: 'cb',
  },
  {
    idq: 'chatExpFunCongrUse3Q',
    question:
      "Le chatbot permet-il de rechercher et d'acheter plus rapidement ?",
    idAns: 'chatExpFunCongrUse3',
    idVal: 'chatExpFunCongrUse3Val',
    qGlobId: 'chatExp',
    globId: 'cb',
  },
  // {
  //   idq: 'chatExpFunCongrUse4Q',
  //   question: "Le chatbot facilite-t-il l'achat ?",
  //   idAns: 'chatExpFunCongrUse4',
  //   idVal: 'chatExpFunCongrUse4Val',
  //   qGlobId: 'chatExp',
  //   globId: 'cb',
  // },
  // Brand congruency
  {
    idq: 'chatExpBrandCong1Q',
    question:
      "Dans quelle mesure le chatbot de la vidéocorrespond-il à l'image que tu as de la marque ?",
    idAns: 'chatExpBrandCong1',
    idVal: 'chatExpBrandCong1Val',
    qGlobId: 'chatExp',
    globId: 'cb',
  },
  {
    idq: 'chatExpBrandCong2Q',
    question:
      'Le comportement du chatbot est-il logique par rapport à ta perception de la marque ?',
    idAns: 'chatExpBrandCong2',
    idVal: 'chatExpBrandCong2Val',
    qGlobId: 'chatExp',
    globId: 'cb',
  },
  {
    idq: 'chatExpBrandCong3Q',
    question: 'Le chatbot est-il adapté à la marque ?',
    idAns: 'chatExpBrandCong3',
    idVal: 'chatExpBrandCong3Val',
    qGlobId: 'chatExp',
    globId: 'cb',
  },
  // Hedonic Value
  {
    idq: 'chatExpHedo1Q',
    question:
      "Quel a été le degré de confort lors de l'interaction avec le chatbot ?",
    idAns: 'chatExpHedo1',
    idVal: 'chatExpHedo1Val',
    qGlobId: 'chatExp',
    globId: 'cb',
  },
  {
    idq: 'chatExpHedo2Q',
    question: "L'interaction avec le chatbot a-t-elle été passionnante ?",
    idAns: 'chatExpHedo2',
    idVal: 'chatExpHedo2Val',
    qGlobId: 'chatExp',
    globId: 'cb',
  },
  {
    idq: 'chatExpHedo3Q',
    question: 'Est-ce que les échanges avec le chatbot ont été agréables ?',
    idAns: 'chatExpHedo3',
    idVal: 'chatExpHedo3Val',
    qGlobId: 'chatExp',
    globId: 'cb',
  },
  // {
  //   idq: 'chatExpHedo4Q',
  //   question: 'Le dialogue avec le chatbot a-t-il été intéressant ?',
  //   idAns: 'chatExpHedo4',
  //   idVal: 'chatExpHedo4Val',
  //   qGlobId: 'chatExp',
  //   globId: 'cb',
  // },
  // {
  //   idq: 'chatExpHedo5Q',
  //   question: "Est-ce que tu trouves amusant d'interagir avec le chatbot ?",
  //   idAns: 'chatExpHedo5',
  //   idVal: 'chatExpHedo5Val',
  //   qGlobId: 'chatExp',
  //   globId: 'cb',
  // },
  // Social Congruency
  {
    idq: 'chatExpSocCong1Q',
    question: 'En contact avec le chatbot, as-tu ressenti un contact humain ?',
    idAns: 'chatExpSocCong1',
    idVal: 'chatExpSocCong1Val',
    qGlobId: 'chatExp',
    globId: 'cb',
  },
  {
    idq: 'chatExpSocCong2Q',
    question:
      'À ton avis, même si tu ne peux pas voir le chatbot en vrai, as-tu ressenti une cordialité humaine ?',
    idAns: 'chatExpSocCong2',
    idVal: 'chatExpSocCong2Val',
    qGlobId: 'chatExp',
    globId: 'cb',
  },
  // {
  //   idq: 'chatExpSocCong3Q',
  //   question:
  //     'En discutant avec le chatbot, as-tu ressenti une impression de sociabilité ?',
  //   idAns: 'chatExpSocCong3',
  //   idVal: 'chatExpSocCong3Val',
  //   qGlobId: 'chatExp',
  //   globId: 'cb',
  // },
  {
    idq: 'chatExpSocCong4Q',
    question:
      'As-tu eu le sentiment de vivre une expérience qui inspire confiance ?',
    idAns: 'chatExpSocCong4',
    idVal: 'chatExpSocCong4Val',
    qGlobId: 'chatExp',
    globId: 'cb',
  },
  // Branded chatbot experience
  {
    idq: 'chatBrandExp1Q',
    question: 'Le design et le langage du chatbot étaient-ils agréables ?',
    idAns: 'chatBrandExp1',
    idVal: 'chatBrandExp1Val',
    qGlobId: 'chatExp',
    globId: 'cb',
  },
  // {
  //   idq: 'chatBrandExp2Q',
  //   question: 'Le chatbot était-il facile à utiliser ?',
  //   idAns: 'chatBrandExp2',
  //   idVal: 'chatBrandExp2Val',
  //   qGlobId: 'chatExp',
  //   globId: 'cb',
  // },
  {
    idq: 'chatBrandExp3Q',
    question: 'Le chatbot réagit-il toujours rapidement ?',
    idAns: 'chatBrandExp3',
    idVal: 'chatBrandExp3Val',
    qGlobId: 'chatExp',
    globId: 'cb',
  },
  // {
  //   idq: 'chatBrandExp4Q',
  //   question: 'Les réponses du chatbot sont-elles toujours pertinentes ?',
  //   idAns: 'chatBrandExp4',
  //   idVal: 'chatBrandExp4Val',
  //   qGlobId: 'chatExp',
  //   globId: 'cb',
  // },
  {
    idq: 'chatBrandExp5Q',
    question: 'Le chatbot fournit-il toujours les informations exactes ?',
    idAns: 'chatBrandExp5',
    idVal: 'chatBrandExp5Val',
    qGlobId: 'chatExp',
    globId: 'cb',
  },
  // Patronage Intention
  {
    idq: 'chatPatrong1Q',
    question: "Serais-tu prêt à faire des achats avec l'aide de ce chatbot ?",
    idAns: 'chatPatrong1',
    idVal: 'chatPatrong1Val',
    qGlobId: 'chatExp',
    globId: 'cb',
  },
  {
    idq: 'chatPatrong2Q',
    question:
      'Quelle est la probabilité que tu achètes en utilisant ce chatbot ?',
    idAns: 'chatPatrong2',
    idVal: 'chatPatrong2Val',
    qGlobId: 'chatExp',
    globId: 'cb',
  },
  {
    idq: 'chatPatrong3Q',
    question: 'Serais-tu enclin à recommander ce chatbot à tes proches ?',
    idAns: 'chatPatrong3',
    idVal: 'chatPatrong3Val',
    qGlobId: 'chatExp',
    globId: 'cb',
  },
]

//// EXPORT CHATBOT CX RANDOMIZED /////////
export const chatExpFr = flatten([...botCxIntFr, randomize(chatExpFrBef)])
//// END  BRQ RANDOMIZED /////////

/////////////// Ideal Variable Color Blue ///////////////
// Welcome Mesage
const colBluIntrFr = [
  {
    id: 'colBlu',
    message:
      "A présent, j'aimerais savoir ce que tu aimes de la couleur bleue ! 💧",
    qGlobId: 'colBlu',
    globId: 'blu',
  },
]

const colBlueFrBef = [
  {
    idq: 'col1Blu',
    question: 'Tu préfères le bleu aux autres couleurs',
    idAns: 'col1Blu',
    idVal: 'col1Blu',
    qGlobId: 'colBlu',
    globId: 'blu',
  },
  {
    idq: 'col2Blu',
    question: 'Tu apprécies la couleur bleue',
    idAns: 'col2Blu',
    idVal: 'col2Blu',
    qGlobId: 'colBlu',
    globId: 'blu',
  },
  {
    idq: 'col3Blu',
    question: 'Tu aimes les habits bleus',
    idAns: 'col3Blu',
    idVal: 'col3Blu',
    qGlobId: 'colBlu',
    globId: 'blu',
  },
  {
    idq: 'col4Blu',
    question: 'Tu aimes la peinture bleue',
    idAns: 'col4Blu',
    idVal: 'col4Blu',
    qGlobId: 'colBlu',
    globId: 'blu',
  },
]
//// EXPORT COLOR BLUE RANDOMIZED /////////
export const colBluFr = flatten([...colBluIntrFr, randomize(colBlueFrBef)])
//// END  COLOR BLUE /////////

/////////////////////////////////////
//////////// ENGLISH TEXT ////////////
/////////////////////////////////////
/////////////// Antrhopo ///////////////
const anthrIntrEn =
  // Welcome Mesage
  {
    id: 'ant',
    message: "First of all, let's imagine that this mark can be a person 😎.",
    qGlobId: 'ant',
    globId: 'a',
  }
const antrhopoEnBef = [
  // Moral Virtue
  {
    idq: 'antVir1Q',
    question: 'Is the brand trustworthy?',
    idAns: 'antVir1',
    idVal: 'antVir1Val',
    qGlobId: 'ant',
    globId: 'a',
  },
  {
    idq: 'antVir2Q',
    question: 'The brand is guided by principles/rules?',
    idAns: 'antVir2',
    idVal: 'antVir2Val',
    qGlobId: 'ant',
    globId: 'a',
  },
  {
    idq: 'antVir3Q',
    question: 'This brand is honest?',
    idAns: 'antVir3',
    idVal: 'antVir3Val',
    qGlobId: 'ant',
    globId: 'a',
  },
  // Experience
  {
    idq: 'antExp1Q',
    question: 'This brand is able to think?',
    idAns: 'antExp1',
    idVal: 'antExp1Val',
    qGlobId: 'ant',
    globId: 'a',
  },
  {
    idq: 'antExp2Q',
    question: 'Do you think this brand can imagine things by itself?',
    idAns: 'antExp2',
    idVal: 'antExp2Val',
    qGlobId: 'ant',
    globId: 'a',
  },
  {
    idq: 'antExp3Q',
    question: 'Could it be that this brand has the ability to be rational?',
    idAns: 'antExp3',
    idVal: 'antExp3Val',
    qGlobId: 'ant',
    globId: 'a',
  },

  // Emotionality
  {
    idq: 'antEmo1Q',
    question:
      'Can the brand feel regret for actions that it considers shameful?',
    idAns: 'antEmo1',
    idVal: 'antEmo1Val',
    qGlobId: 'ant',
    globId: 'a',
  },
  {
    idq: 'antEmo2Q',
    question:
      'In your opinion, can the brand feel responsible when it hurts someone through its behavior?',
    idAns: 'antEmo2',
    idVal: 'antEmo2Val',
    qGlobId: 'ant',
    globId: 'a',
  },
  {
    idq: 'antEmo3Q',
    question:
      'Is there any possibility that the brand feels embarrassed when people express negative opinions and judgments about it?',
    idAns: 'antEmo3',
    idVal: 'antEmo3Val',
    qGlobId: 'ant',
    globId: 'a',
  },
]
//// EXPORT ANTHROPOMORPH RANDOMIZED /////////
export const antrhopoEn = flatten([...[anthrIntrEn], randomize(antrhopoEnBef)])
//// END  ANTHROPOMORPH RANDOMIZED /////////

/////////////// Social Distance ///////////////
const socIntrEn =
  // Welcome Mesage
  {
    id: 'socDi',
    message:
      "Great!, Now, assume the brand is someone you know very well 😎 I'd like to understand what kind of relationship you consider having with it.",
    qGlobId: 'socDi',
    globId: 's',
  }
const socialDisEnBef = [
  // Other in Self
  {
    img: 'oisen',
    idq: 'socDiOis1Q',
    question:
      'Which image most accurately represents your relationship to this brand?',
    idAns: 'socDiOis1',
    idVal: 'socDiOis1Val',
    qGlobId: 'socDi',
    globId: 's',
  },
  // Social Proximity
  {
    idq: 'socDiProx1Q',
    question: 'In general, how much do you think the brand is like you?',
    idAns: 'socDiProx1',
    idVal: 'socDiProx1Val',
    qGlobId: 'socDi',
    globId: 's',
  },
  {
    idq: 'socDiProx2Q',
    question: 'How close is the brand to you (i.e. socially close)?',
    idAns: 'socDiProx2',
    idVal: 'socDiProx2Val',
    qGlobId: 'socDi',
    globId: 's',
  },
]
//// EXPORT SOCIAL DISTANCE RANDOMIZED /////////
export const socialDisEn = flatten([...[socIntrEn], randomize(socialDisEnBef)])
//// END  SOCIAL DISTANCE RANDOMIZED /////////

/////////////// BRAND LOVE ///////////////
const brndLvIntrEn =
  // Welcome Mesage
  {
    id: 'brLv',
    message: "Now let's talk about love! ❤️❤️",
    qGlobId: 'brLv',
    globId: 'bl',
  }
const brandLoveEnBef = [
  // Self-brand integration
  {
    idq: 'brLvSelf1Q',
    question:
      'Does the use of the brand say something "true" and " deep" about who you are as an individual?',
    idAns: 'brLvSelf1',
    idVal: 'brLv1SelfVal',
    qGlobId: 'brLv',
    globId: 'bl',
  },
  // Passion-driven behaviors
  {
    idq: 'brLvPassi1Q',
    question:
      "When using this brand's products: To what extent do you feel like yourself?",
    idAns: 'brLvPassi1',
    idVal: 'brLvPassi1Val',
    qGlobId: 'brLv',
    globId: 'bl',
  },
  // Emotional attachment
  {
    idq: 'brLv1AttachQ',
    question: 'Do you feel emotionally connected to this brand?',
    idAns: 'brLvAttach1',
    idVal: 'brLvAttach1Val',
    qGlobId: 'brLv',
    globId: 'bl',
  },
  //Long-term relationship
  {
    idq: 'brLvLoTe1Q',
    question:
      'To what extent do you plan to continue using the brand in the future?',
    idAns: 'brLvLoTe1',
    idVal: 'brLvLoTe1Val',
    qGlobId: 'brLv',
    globId: 'bl',
  },
  // Anticipated separation distress
  {
    idq: 'brLvSepar1Q',
    question:
      "Let's say the brand disappeared, about how anxious would you feel? 😰",
    idAns: 'brLvSepar1',
    idVal: 'brLvSepar1Val',
    qGlobId: 'brLv',
    globId: 'bl',
  },
  // Attitude valence
  {
    idq: 'brLvVale1Q',
    question:
      'Overall, what are your feelings and evaluation towards the brand (👎 1 negative - 6 positive 👍).',
    idAns: 'brLvVale1',
    idVal: 'brLvVale1Val',
    qGlobId: 'brLv',
    globId: 'bl',
  },
]
//// EXPORT BRAND LOVE RANDOMIZED /////////
export const brandLoveEn = flatten([
  ...[brndLvIntrEn],
  randomize(brandLoveEnBef),
])
//// END  BRAND LOVE RANDOMIZED /////////

/////////////// HOT & COLD BRQ ///////////////
const brqIntrEn =
  // Welcome Mesage
  {
    id: 'brq',
    message: "Let's move on to the next topic!",
    qGlobId: 'brq',
    globId: 'br',
  }
// {
//   id: 'brq',
//   message: "That's it, we have reached the first step! ⭐⭐⭐⭐⭐",
//   trigger: 'followBrq',
// }
const brqEnBef = [
  // Option Continue

  // {
  //   id: 'nextOpt',
  //   options: [
  //     { value: 'si', label: 'Yes 👍', trigger: '5brq' },
  //     // { value: 'no', label: 'No 👎', trigger: 'noContinue' },
  //   ],
  // },
  // // NO, Save and continue after
  // {
  //   id: 'noContinue',
  //   message:
  //     'Don\'t worry, you can continue later if you want 🙂 click on "save" to continue later from this point',
  //   trigger: 'saveInfo',
  // },
  // {
  //   id: 'saveInfo',
  //   saveInfo: true,
  // },
  // Cold BRQ
  // Satisfaction
  {
    idq: 'brqSat1Q',
    question: 'Are you still satisfied with the decision to use the brand?',
    idAns: 'brqSat1',
    idVal: 'brqSat1Val',
    qGlobId: 'brq',
    globId: 'br',
  },
  {
    idq: 'brqSat2Q',
    question: 'Are you fully satisfied with the brand?',
    idAns: 'brqSat2',
    idVal: 'brqSat2Val',
    qGlobId: 'brq',
    globId: 'br',
  },
  {
    idq: 'brqSat3Q',
    question:
      'So, does the brand offer exactly what you expect when you buy these types of products?',
    idAns: 'brqSAt3',
    idVal: 'brqSat3Val',
    qGlobId: 'brq',
    globId: 'br',
  },
  // Brand trust
  {
    idq: 'brqTru1Q',
    question: 'Do you trust this brand?',
    idAns: 'brqTru1',
    idVal: 'brqTru1Val',
    qGlobId: 'brq',
    globId: 'br',
  },
  {
    idq: 'brqTru2Q',
    question: "Do you think it's an honest brand?",
    idAns: 'brqTru2',
    idVal: 'brqTru2Val',
    qGlobId: 'brq',
    globId: 'br',
  },
  {
    idq: 'brqTru3Q',
    question: 'How reliable do you think the brand is?',
    idAns: 'brqTru3',
    idVal: 'brqTru3Val',
    qGlobId: 'brq',
    globId: 'br',
  },
  // Hot BRQ
  // Commitment
  {
    idq: 'brqCommit1Q',
    question: 'Do you feel you are loyal to this brand?',
    idAns: 'brqCommit1',
    idVal: 'brqCommit1Val',
    qGlobId: 'brq',
    globId: 'br',
  },
  {
    idq: 'brqCommit2Q',
    question: 'This brand can rely on you at all times?',
    idAns: 'brqCommit2',
    idVal: 'brqCommit2Val',
    qGlobId: 'brq',
    globId: 'br',
  },
  {
    idq: 'brqCommit3Q',
    question: 'Will you stay with this brand against all odds?',
    idAns: 'brqCommit3',
    idVal: 'brqCommit3Val',
    qGlobId: 'brq',
    globId: 'br',
  },
  // Intimacy
  {
    idq: 'brqInti1Q',
    question:
      'Compared to other brands, do you feel much more identified with this brand?',
    idAns: 'brqInti1',
    idVal: 'brqInti1Val',
    qGlobId: 'brq',
    globId: 'br',
  },
  {
    idq: 'brqInti2Q',
    question: 'Do you feel emotionally connected to this brand?',
    idAns: 'brqInti2',
    idVal: 'brqInti2Val',
    qGlobId: 'brq',
    globId: 'br',
  },
  // Passion
  {
    idq: 'brqPassi1Q',
    question: 'Are there any times when you really want to use this brand?',
    idAns: 'brqPassi1',
    idVal: 'brqPassi1Val',
    qGlobId: 'brq',
    globId: 'br',
  },
  {
    idq: 'brqPassi2Q',
    question:
      "Do you feel that something is missing when you don't use the brand for a while?",
    idAns: 'brqPassi2',
    idVal: 'brqPassi2Val',
    qGlobId: 'brq',
    globId: 'br',
  },
]
//// EXPORT BRQ RANDOMIZED /////////
export const brqEn = flatten([...[brqIntrEn], randomize(brqEnBef)])
//// END  BRQ RANDOMIZED /////////

/////////////// CHATBOT AFFECTIVE & COGNITIVE EXPERIENCE ///////////////
const botCxIntEn =
  // Welcome Mesage
  // {
  //   id: 'chatExp',
  //   message: "Wow, we're almost there!",
  //   trigger: 'prepare',
  // },
  [
    {
      id: 'chatExp',
      message:
        "Now let's talk about the experience you had with the chatbot you watched in the brand's product purchase! 🤖🤖",
      qGlobId: 'chatExp',
      globId: 'cb',
    },
    {
      id: 'chatExp',
      message:
        'Upon purchase, and after interacting with the chatbot, I would like to get your feedback on the following aspects:',
      qGlobId: 'chatExp',
      globId: 'cb',
    },
  ]

const chatExpEnBef = [
  // Functional Congruency
  //// Perceived Helpfulness
  {
    idq: 'chatExpFunCongrHelp1Q',
    question: "Was the chatbot's use suitable?",
    idAns: 'chatExpFunCongrHelp1',
    idVal: 'chatExpFunCongrHelp1Val',
    qGlobId: 'chatExp',
    globId: 'cb',
  },
  {
    idq: 'chatExpFunCongrHelp3Q',
    question: 'Did the chatbot provide the necessary information?',
    idAns: 'chatExpFunCongrHelp3',
    idVal: 'chatExpFunCongrHelp3Val',
    qGlobId: 'chatExp',
    globId: 'cb',
  },
  {
    idq: 'chatExpFunCongrHelp2Q',
    question:
      'If the purchase was real, what would have been the positive impact of using the chatbot on the buying decision?',
    idAns: 'chatExpFunCongrHelp2',
    idVal: 'chatExpFunCongrHelp2Val',
    qGlobId: 'chatExp',
    globId: 'cb',
  },
  //// Perceived usefulness
  {
    idq: 'chatExpFunCongrUse1Q',
    question: "Do you find the chatbot useful for buying the brand's products?",
    idAns: 'chatExpFunCongrUse1',
    idVal: 'chatExpFunCongrUse1Val',
    qGlobId: 'chatExp',
    globId: 'cb',
  },
  {
    idq: 'chatExpFunCongrUse2Q',
    question:
      'In your opinion, how can chatbots help improve your efficiency in the research and shopping process?',
    idAns: 'chatExpFunCongrUse2',
    idVal: 'chatExpFunCongrUse2Val',
    qGlobId: 'chatExp',
    globId: 'cb',
  },
  {
    idq: 'chatExpFunCongrUse3Q',
    question: 'Can the chatbot allow you to search and buy faster?',
    idAns: 'chatExpFunCongrUse3',
    idVal: 'chatExpFunCongrUse3Val',
    qGlobId: 'chatExp',
    globId: 'cb',
  },
  // {
  //   idq: 'chatExpFunCongrUse4Q',
  //   question: 'Is the chatbot making the purchase easier?',
  //   idAns: 'chatExpFunCongrUse4',
  //   idVal: 'chatExpFunCongrUse4Val',
  //   qGlobId: 'chatExp',
  //   globId: 'cb',
  // },
  // Brand congruency
  {
    idq: 'chatExpBrandCong1Q',
    question:
      'How well does the chatbot match the image you have of the brand?',
    idAns: 'chatExpBrandCong1',
    idVal: 'chatExpBrandCong1Val',
    qGlobId: 'chatExp',
    globId: 'cb',
  },
  {
    idq: 'chatExpBrandCong2Q',
    question:
      "Does the chatbot's behavior make sense in relation to your perception of the brand?",
    idAns: 'chatExpBrandCong2',
    idVal: 'chatExpBrandCong2Val',
    qGlobId: 'chatExp',
    globId: 'cb',
  },
  {
    idq: 'chatExpBrandCong3Q',
    question: 'Do you think the chatbot is suitable for the brand?',
    idAns: 'chatExpBrandCong3',
    idVal: 'chatExpBrandCong3Val',
    qGlobId: 'chatExp',
    globId: 'cb',
  },
  // Hedonic Value
  {
    idq: 'chatExpHedo1Q',
    question: 'How comfortable was the interaction with the chatbot?',
    idAns: 'chatExpHedo1',
    idVal: 'chatExpHedo1Val',
    qGlobId: 'chatExp',
    globId: 'cb',
  },
  {
    idq: 'chatExpHedo2Q',
    question: 'Was the interaction with the chatbot exciting?',
    idAns: 'chatExpHedo2',
    idVal: 'chatExpHedo2Val',
    qGlobId: 'chatExp',
    globId: 'cb',
  },
  {
    idq: 'chatExpHedo3Q',
    question: 'Were the exchanges with the chatbot pleasant?',
    idAns: 'chatExpHedo3',
    idVal: 'chatExpHedo3Val',
    qGlobId: 'chatExp',
    globId: 'cb',
  },
  // {
  //   idq: 'chatExpHedo4Q',
  //   question: 'How interesting was the dialogue with the chatbot?',
  //   idAns: 'chatExpHedo4',
  //   idVal: 'chatExpHedo4Val',
  //   qGlobId: 'chatExp',
  //   globId: 'cb',
  // },
  // {
  //   idq: 'chatExpHedo5Q',
  //   question: 'Do you find it fun to interact with the chatbot?',
  //   idAns: 'chatExpHedo5',
  //   idVal: 'chatExpHedo5Val',
  //   qGlobId: 'chatExp',
  //   globId: 'cb',
  // },
  // Social Congruency
  {
    idq: 'chatExpSocCong1Q',
    question: 'When contacting the chatbot, did you feel a human touch?',
    idAns: 'chatExpSocCong1',
    idVal: 'chatExpSocCong1Val',
    qGlobId: 'chatExp',
    globId: 'cb',
  },
  {
    idq: 'chatExpSocCong2Q',
    question:
      "In your opinion, even if you can't see the chatbot in real life, did you feel a human kindness?",
    idAns: 'chatExpSocCong2',
    idVal: 'chatExpSocCong2Val',
    qGlobId: 'chatExp',
    globId: 'cb',
  },
  // {
  //   idq: 'chatExpSocCong3Q',
  //   question:
  //     'When chatting with the chatbot, did you feel a sense of sociability?',
  //   idAns: 'chatExpSocCong3',
  //   idVal: 'chatExpSocCong3Val',
  //   qGlobId: 'chatExp',
  //   globId: 'cb',
  // },
  {
    idq: 'chatExpSocCong4Q',
    question: 'Did you feel you had a confidence-inspiring experience?',
    idAns: 'chatExpSocCong4',
    idVal: 'chatExpSocCong4Val',
    qGlobId: 'chatExp',
    globId: 'cb',
  },
  // Branded chatbot experience
  {
    idq: 'chatBrandExp1Q',
    question: 'Was the design and language of the chatbot pleasant?',
    idAns: 'chatBrandExp1',
    idVal: 'chatBrandExp1Val',
    qGlobId: 'chatExp',
    globId: 'cb',
  },
  // {
  //   idq: 'chatBrandExp2Q',
  //   question: 'Was the chatbot easy to use?',
  //   idAns: 'chatBrandExp2',
  //   idVal: 'chatBrandExp2Val',
  //   qGlobId: 'chatExp',
  //   globId: 'cb',
  // },
  {
    idq: 'chatBrandExp3Q',
    question: 'Does the chatbot always react quickly?',
    idAns: 'chatBrandExp3',
    idVal: 'chatBrandExp3Val',
    qGlobId: 'chatExp',
    globId: 'cb',
  },
  // {
  //   idq: 'chatBrandExp4Q',
  //   question: "Were the chatbot's responses always relevant?",
  //   idAns: 'chatBrandExp4',
  //   idVal: 'chatBrandExp4Val',
  //   qGlobId: 'chatExp',
  //   globId: 'cb',
  // },
  {
    idq: 'chatBrandExp5Q',
    question: 'Is the chatbot always providing the right information?',
    idAns: 'chatBrandExp5',
    idVal: 'chatBrandExp5Val',
    qGlobId: 'chatExp',
    globId: 'cb',
  },
  // Patronage Intention
  {
    idq: 'chatPatrong1Q',
    question:
      'Are you willing to make a purchase with the help of this chatbot?',
    idAns: 'chatPatrong1',
    idVal: 'chatPatrong1Val',
    qGlobId: 'chatExp',
    globId: 'cb',
  },
  {
    idq: 'chatPatrong2Q',
    question: 'What is the probability that you will buy using this chatbot?',
    idAns: 'chatPatrong2',
    idVal: 'chatPatrong2Val',
    qGlobId: 'chatExp',
    globId: 'cb',
  },
  {
    idq: 'chatPatrong3Q',
    question: 'Would you recommend this chatbot to your friends and family?',
    idAns: 'chatPatrong3',
    idVal: 'chatPatrong3Val',
    qGlobId: 'chatExp',
    globId: 'cb',
  },
]
//// EXPORT CHATBOT CX RANDOMIZED /////////
export const chatExpEn = flatten([...botCxIntEn, randomize(chatExpEnBef)])
//// END  BRQ RANDOMIZED /////////

/////////////// Ideal Variable Color Blue ///////////////
// Welcome Mesage
const colBluIntrEn = [
  {
    id: 'colBlu',
    message:
      "At this point, I'd love to know what you like about the color blue! 💧",
    qGlobId: 'colBlu',
    globId: 'blu',
  },
]

const colBlueEnBef = [
  {
    idq: 'col1Blu',
    question: 'You prefer blue to other colors',
    idAns: 'col1Blu',
    idVal: 'col1Blu',
    qGlobId: 'colBlu',
    globId: 'blu',
  },
  {
    idq: 'col2Blu',
    question: 'You like the color blue',
    idAns: 'col2Blu',
    idVal: 'col2Blu',
    qGlobId: 'colBlu',
    globId: 'blu',
  },
  {
    idq: 'col3Blu',
    question: 'You like blue clothes',
    idAns: 'col3Blu',
    idVal: 'col3Blu',
    qGlobId: 'colBlu',
    globId: 'blu',
  },
  {
    idq: 'col4Blu',
    question: 'You like blue paint',
    idAns: 'col4Blu',
    idVal: 'col4Blu',
    qGlobId: 'colBlu',
    globId: 'blu',
  },
]
//// EXPORT COLOR BLUE RANDOMIZED /////////
export const colBluEn = flatten([...colBluIntrEn, randomize(colBlueEnBef)])
//// END  COLOR BLUE /////////

/////////////////////////////////////
//////////// PORTUGUESE TEXT ////////////
/////////////////////////////////////
/////////////// Antrhopo ///////////////
const anthrIntrPtg =
  // Welcome Mesage
  {
    id: 'ant',
    message:
      'Antes que nada, imaginemos que esta marca poderia ser uma pessoa 😎.',
    qGlobId: 'ant',
    globId: 'a',
  }
const antrhopoPtgBef = [
  // Moral Virtue
  {
    idq: 'antVir1Q',
    question: 'A marca é digna de confiança?',
    idAns: 'antVir1',
    idVal: 'antVir1Val',
    qGlobId: 'ant',
    globId: 'a',
  },
  {
    idq: 'antVir2Q',
    question: 'Esta marca é guiada por princípios/regras?',
    idAns: 'antVir2',
    idVal: 'antVir2Val',
    qGlobId: 'ant',
    globId: 'a',
  },
  {
    idq: 'antVir3Q',
    question: 'Esta marca é honesta?',
    idAns: 'antVir3',
    idVal: 'antVir3Val',
    qGlobId: 'ant',
    globId: 'a',
  },
  // Experience
  {
    idq: 'antExp1Q',
    question: 'Esta marca é capaz de pensar?',
    idAns: 'antExp1',
    idVal: 'antExp1Val',
    qGlobId: 'ant',
    globId: 'a',
  },
  {
    idq: 'antExp2Q',
    question: 'Você acha que esta marca pode imaginar as coisas sozinha?',
    idAns: 'antExp2',
    idVal: 'antExp2Val',
    qGlobId: 'ant',
    globId: 'a',
  },
  {
    idq: 'antExp3Q',
    question: 'Será que esta marca tem a capacidade de ser racional?',
    idAns: 'antExp3',
    idVal: 'antExp3Val',
    qGlobId: 'ant',
    globId: 'a',
  },

  // Emotionality
  {
    idq: 'antEmo1Q',
    question:
      'A marca pode sentir-se magoada por ações que considera vergonhosas',
    idAns: 'antEmo1',
    idVal: 'antEmo1Val',
    qGlobId: 'ant',
    globId: 'a',
  },
  {
    idq: 'antEmo2Q',
    question:
      'Na sua opinião, a marca pode sentir-se responsável quando prejudica alguém através de seu comportamento?',
    idAns: 'antEmo2',
    idVal: 'antEmo2Val',
    qGlobId: 'ant',
    globId: 'a',
  },
  {
    idq: 'antEmo3Q',
    question:
      'A marca pode se sentir envergonhada quando as pessoas expressam opiniões e julgamentos negativos a respeito dela?',
    idAns: 'antEmo3',
    idVal: 'antEmo3Val',
    qGlobId: 'ant',
    globId: 'a',
  },
]
//// EXPORT ANTHROPOMORPH RANDOMIZED /////////
export const antrhopoPtg = flatten([
  ...[anthrIntrPtg],
  randomize(antrhopoPtgBef),
])
//// END  ANTHROPOMORPH RANDOMIZED /////////

/////////////// Social Distance ///////////////
const socIntrPtg =
  // Welcome Mesage
  {
    id: 'socDi',
    message:
      'Que legal! Agora, assuma que a marca é alguém que você conhece muito bem 😎 Eu gostaria de entender que tipo de relacionamento você considera ter com ela.',
    qGlobId: 'socDi',
    globId: 's',
  }
const socialDisPtgBef = [
  // Other in Self
  {
    img: 'oispt',
    idq: 'socDiOis1Q',
    question:
      'Qual imagem representa com mais precisão a sua relação com esta marca?',
    idAns: 'socDiOis1',
    idVal: 'socDiOis1Val',
    qGlobId: 'socDi',
    globId: 's',
  },
  // Social Proximity
  {
    idq: 'socDiProx1Q',
    question: 'Em geral, até que ponto você considera que a marca é como você?',
    idAns: 'socDiProx1',
    idVal: 'socDiProx1Val',
    qGlobId: 'socDi',
    globId: 's',
  },
  {
    idq: 'socDiProx2Q',
    question:
      'O quanto a marca é próxima de você (ou seja, socialmente próxima)?',
    idAns: 'socDiProx2',
    idVal: 'socDiProx2Val',
    qGlobId: 'socDi',
    globId: 's',
  },
]
//// EXPORT SOCIAL DISTANCE RANDOMIZED /////////
export const socialDisPtg = flatten([
  ...[socIntrPtg],
  randomize(socialDisPtgBef),
])
//// END  SOCIAL DISTANCE RANDOMIZED /////////

/////////////// BRAND LOVE ///////////////
const brndLvIntrPtg =
  // Welcome Mesage
  {
    id: 'brLv',
    message: 'Vamos falar de amor agora! ❤️❤️',
    qGlobId: 'brLv',
    globId: 'bl',
  }
const brandLovePtgBef = [
  // Self-brand integration
  {
    idq: 'brLvSelf1Q',
    question:
      'O uso da marca diz algo "verdadeiro" e "profundo" sobre quem você é como indivíduo?',
    idAns: 'brLvSelf1',
    idVal: 'brLv1SelfVal',
    qGlobId: 'brLv',
    globId: 'bl',
  },
  // Passion-driven behaviors
  {
    idq: 'brLvPassi1Q',
    question:
      '•	Ao utilizar os produtos desta marca: Em que medida se sente como si próprio?',
    idAns: 'brLvPassi1',
    idVal: 'brLvPassi1Val',
    qGlobId: 'brLv',
    globId: 'bl',
  },
  // Emotional attachment
  {
    idq: 'brLv1AttachQ',
    question: 'Você sente-se emocionalmente ligado a esta marca?',
    idAns: 'brLvAttach1',
    idVal: 'brLvAttach1Val',
    qGlobId: 'brLv',
    globId: 'bl',
  },
  //Long-term relationship
  {
    idq: 'brLvLoTe1Q',
    question: 'Até que ponto você planeja continuar usando a marca no futuro?',
    idAns: 'brLvLoTe1',
    idVal: 'brLvLoTe1Val',
    qGlobId: 'brLv',
    globId: 'bl',
  },
  // Anticipated separation distress
  {
    idq: 'brLvSepar1Q',
    question:
      'Digamos que a marca desapareceu, quanta ansiedade você sentiria? 😰',
    idAns: 'brLvSepar1',
    idVal: 'brLvSepar1Val',
    qGlobId: 'brLv',
    globId: 'bl',
  },
  // Attitude valence
  {
    idq: 'brLvVale1Q',
    question:
      'Em geral, quais são seus sentimentos e apreciação em relação à marca (👎 1 negativo - 6 positivo 👍)',
    idAns: 'brLvVale1',
    idVal: 'brLvVale1Val',
    qGlobId: 'brLv',
    globId: 'bl',
  },
]
//// EXPORT BRAND LOVE RANDOMIZED /////////
export const brandLovePtg = flatten([
  ...[brndLvIntrPtg],
  randomize(brandLovePtgBef),
])
//// END  BRAND LOVE RANDOMIZED /////////

/////////////// HOT & COLD BRQ ///////////////
const brqIntrPtg =
  // Welcome Mesage
  {
    id: 'brq',
    message: 'Vamos ao próximo tema!',
    qGlobId: 'brq',
    globId: 'br',
  }
// {
//   id: 'brq',
//   message: "That's it, we have reached the first step! ⭐⭐⭐⭐⭐",
//   trigger: 'followBrq',
// }
const brqPtgBef = [
  // Option Continue

  // {
  //   id: 'nextOpt',
  //   options: [
  //     { value: 'si', label: 'Yes 👍', trigger: '5brq' },
  //     // { value: 'no', label: 'No 👎', trigger: 'noContinue' },
  //   ],
  // },
  // // NO, Save and continue after
  // {
  //   id: 'noContinue',
  //   message:
  //     'Don\'t worry, you can continue later if you want 🙂 click on "save" to continue later from this point',
  //   trigger: 'saveInfo',
  // },
  // {
  //   id: 'saveInfo',
  //   saveInfo: true,
  // },
  // Cold BRQ
  // Satisfaction
  {
    idq: 'brqSat1Q',
    question: 'Você continua satisfeito com a decisão de usar a marca?',
    idAns: 'brqSat1',
    idVal: 'brqSat1Val',
    qGlobId: 'brq',
    globId: 'br',
  },
  {
    idq: 'brqSat2Q',
    question: 'Você está totalmente convencido com a marca?',
    idAns: 'brqSat2',
    idVal: 'brqSat2Val',
    qGlobId: 'brq',
    globId: 'br',
  },
  {
    idq: 'brqSat3Q',
    question:
      'A marca oferece exatamente o que você espera quando você compra estes produtos?',
    idAns: 'brqSAt3',
    idVal: 'brqSat3Val',
    qGlobId: 'brq',
    globId: 'br',
  },
  // Brand trust
  {
    idq: 'brqTru1Q',
    question: 'Você confia nesta marca?',
    idAns: 'brqTru1',
    idVal: 'brqTru1Val',
    qGlobId: 'brq',
    globId: 'br',
  },
  {
    idq: 'brqTru2Q',
    question: 'Você acha que é uma marca honesta?',
    idAns: 'brqTru2',
    idVal: 'brqTru2Val',
    qGlobId: 'brq',
    globId: 'br',
  },
  {
    idq: 'brqTru3Q',
    question: 'Até que ponto você acha que a marca é confiável?',
    idAns: 'brqTru3',
    idVal: 'brqTru3Val',
    qGlobId: 'brq',
    globId: 'br',
  },
  // Hot BRQ
  // Commitment
  {
    idq: 'brqCommit1Q',
    question: 'Você se sente leal à marca?',
    idAns: 'brqCommit1',
    idVal: 'brqCommit1Val',
    qGlobId: 'brq',
    globId: 'br',
  },
  {
    idq: 'brqCommit2Q',
    question: 'Esta marca pode confiar em você em todos os momentos?',
    idAns: 'brqCommit2',
    idVal: 'brqCommit2Val',
    qGlobId: 'brq',
    globId: 'br',
  },
  {
    idq: 'brqCommit3Q',
    question: 'Você vai ficar com esta marca contra todas as adversidades?',
    idAns: 'brqCommit3',
    idVal: 'brqCommit3Val',
    qGlobId: 'brq',
    globId: 'br',
  },
  // Intimacy
  {
    idq: 'brqInti1Q',
    question:
      'Em comparação com outras marcas, você se sente muito a mais identificado com esta marca?',
    idAns: 'brqInti1',
    idVal: 'brqInti1Val',
    qGlobId: 'brq',
    globId: 'br',
  },
  {
    idq: 'brqInti2Q',
    question: 'Você sente-se emocionalmente ligado a esta marca?',
    idAns: 'brqInti2',
    idVal: 'brqInti2Val',
    qGlobId: 'brq',
    globId: 'br',
  },
  // Passion
  {
    idq: 'brqPassi1Q',
    question: 'Existe ocasiões em que você realmente quer usar esta marca?',
    idAns: 'brqPassi1',
    idVal: 'brqPassi1Val',
    qGlobId: 'brq',
    globId: 'br',
  },
  {
    idq: 'brqPassi2Q',
    question:
      'Você sente que algo falta quando você não usa a marca por um tempo?',
    idAns: 'brqPassi2',
    idVal: 'brqPassi2Val',
    qGlobId: 'brq',
    globId: 'br',
  },
]
//// EXPORT BRQ RANDOMIZED /////////
export const brqPtg = flatten([...[brqIntrPtg], randomize(brqPtgBef)])
//// END  BRQ RANDOMIZED /////////

/////////////// CHATBOT AFFECTIVE & COGNITIVE EXPERIENCE ///////////////
const botCxIntPtg =
  // Welcome Mesage
  // {
  //   id: 'chatExp',
  //   message: "Wow, we're almost there!",
  //   trigger: 'prepare',
  // },
  [
    {
      id: 'chatExp',
      message:
        '•	Falemos agora da experiência com o chatbot que viu no vídeo sobre a compra do produto da marca! 🤖🤖',
      qGlobId: 'chatExp',
      globId: 'cb',
    },
    {
      id: 'chatExp',
      message:
        'Após a compra, e depois de interagir com o chatbot, gostaria de obter um feedback sobre os seguintes aspectos:',
      qGlobId: 'chatExp',
      globId: 'cb',
    },
  ]

const chatExpPtgBef = [
  // Functional Congruency
  //// Perceived Helpfulness
  {
    idq: 'chatExpFunCongrHelp1Q',
    question: 'O uso do chatbot foi conveniente?',
    idAns: 'chatExpFunCongrHelp1',
    idVal: 'chatExpFunCongrHelp1Val',
    qGlobId: 'chatExp',
    globId: 'cb',
  },
  {
    idq: 'chatExpFunCongrHelp3Q',
    question: 'O chatbot forneceu as informações precisas?',
    idAns: 'chatExpFunCongrHelp3',
    idVal: 'chatExpFunCongrHelp3Val',
    qGlobId: 'chatExp',
    globId: 'cb',
  },
  {
    idq: 'chatExpFunCongrHelp2Q',
    question:
      'Caso a compra fosse real, qual teria sido o impacto positivo do uso do "chatbot" na decisão de compra?',
    idAns: 'chatExpFunCongrHelp2',
    idVal: 'chatExpFunCongrHelp2Val',
    qGlobId: 'chatExp',
    globId: 'cb',
  },
  //// Perceived usefulness
  {
    idq: 'chatExpFunCongrUse1Q',
    question:
      'Você considera que o chatbot é útil para comprar os produtos da marca?',
    idAns: 'chatExpFunCongrUse1',
    idVal: 'chatExpFunCongrUse1Val',
    qGlobId: 'chatExp',
    globId: 'cb',
  },
  {
    idq: 'chatExpFunCongrUse2Q',
    question:
      'Na sua opinião, será que os "chatbots" podem ajudar a melhorar sua eficiência na busca e no processo de compra?',
    idAns: 'chatExpFunCongrUse2',
    idVal: 'chatExpFunCongrUse2Val',
    qGlobId: 'chatExp',
    globId: 'cb',
  },
  {
    idq: 'chatExpFunCongrUse3Q',
    question: 'O chatbot pode permitir que você pesquise e compre mais ágil?',
    idAns: 'chatExpFunCongrUse3',
    idVal: 'chatExpFunCongrUse3Val',
    qGlobId: 'chatExp',
    globId: 'cb',
  },
  // {
  //   idq: 'chatExpFunCongrUse4Q',
  //   question: 'O chatbot está facilitando a compra?',
  //   idAns: 'chatExpFunCongrUse4',
  //   idVal: 'chatExpFunCongrUse4Val',
  //   qGlobId: 'chatExp',
  //   globId: 'cb',
  // },
  // Brand congruency
  {
    idq: 'chatExpBrandCong1Q',
    question:
      'Até que ponto o chatbot corresponde à imagem que você tem da marca?',
    idAns: 'chatExpBrandCong1',
    idVal: 'chatExpBrandCong1Val',
    qGlobId: 'chatExp',
    globId: 'cb',
  },
  {
    idq: 'chatExpBrandCong2Q',
    question:
      'O comportamento do chatbot faz sentido em relação a sua percepção da marca?',
    idAns: 'chatExpBrandCong2',
    idVal: 'chatExpBrandCong2Val',
    qGlobId: 'chatExp',
    globId: 'cb',
  },
  {
    idq: 'chatExpBrandCong3Q',
    question: 'Você acha que o chatbot é adequado para a marca?',
    idAns: 'chatExpBrandCong3',
    idVal: 'chatExpBrandCong3Val',
    qGlobId: 'chatExp',
    globId: 'cb',
  },
  // Hedonic Value
  {
    idq: 'chatExpHedo1Q',
    question: 'A interação com o "chatbot" foi confortável?',
    idAns: 'chatExpHedo1',
    idVal: 'chatExpHedo1Val',
    qGlobId: 'chatExp',
    globId: 'cb',
  },
  {
    idq: 'chatExpHedo2Q',
    question: 'A interação com o chatbot foi emocionante?',
    idAns: 'chatExpHedo2',
    idVal: 'chatExpHedo2Val',
    qGlobId: 'chatExp',
    globId: 'cb',
  },
  {
    idq: 'chatExpHedo3Q',
    question: 'A troca com o chatbot foi agradável?',
    idAns: 'chatExpHedo3',
    idVal: 'chatExpHedo3Val',
    qGlobId: 'chatExp',
    globId: 'cb',
  },
  // {
  //   idq: 'chatExpHedo4Q',
  //   question: 'O quão interessante foi o diálogo com o chatbot?',
  //   idAns: 'chatExpHedo4',
  //   idVal: 'chatExpHedo4Val',
  //   qGlobId: 'chatExp',
  //   globId: 'cb',
  // },
  // {
  //   idq: 'chatExpHedo5Q',
  //   question: 'Você acha que foi divertido interagir com o chatbot?',
  //   idAns: 'chatExpHedo5',
  //   idVal: 'chatExpHedo5Val',
  //   qGlobId: 'chatExp',
  //   globId: 'cb',
  // },
  // Social Congruency
  {
    idq: 'chatExpSocCong1Q',
    question:
      'Ao entrar em contato com o chatbot, você sentiu um toque humano?',
    idAns: 'chatExpSocCong1',
    idVal: 'chatExpSocCong1Val',
    qGlobId: 'chatExp',
    globId: 'cb',
  },
  {
    idq: 'chatExpSocCong2Q',
    question:
      'Na sua opinião, mesmo que não possa ver o chatbot na vida real, sentiu uma amabilidade humana?',
    idAns: 'chatExpSocCong2',
    idVal: 'chatExpSocCong2Val',
    qGlobId: 'chatExp',
    globId: 'cb',
  },
  // {
  //   idq: 'chatExpSocCong3Q',
  //   question:
  //     'Ao conversar com o chatbot, sentiu uma sensação de sociabilidade?',
  //   idAns: 'chatExpSocCong3',
  //   idVal: 'chatExpSocCong3Val',
  //   qGlobId: 'chatExp',
  //   globId: 'cb',
  // },
  {
    idq: 'chatExpSocCong4Q',
    question: 'Você sentiu que foi uma experiência que inspira confiança?',
    idAns: 'chatExpSocCong4',
    idVal: 'chatExpSocCong4Val',
    qGlobId: 'chatExp',
    globId: 'cb',
  },
  // Branded chatbot experience
  {
    idq: 'chatBrandExp1Q',
    question: 'O design e a linguagem do chatbot foi legal?',
    idAns: 'chatBrandExp1',
    idVal: 'chatBrandExp1Val',
    qGlobId: 'chatExp',
    globId: 'cb',
  },
  // {
  //   idq: 'chatBrandExp2Q',
  //   question: 'O chatbot foi fácil de usar?',
  //   idAns: 'chatBrandExp2',
  //   idVal: 'chatBrandExp2Val',
  //   qGlobId: 'chatExp',
  //   globId: 'cb',
  // },
  {
    idq: 'chatBrandExp3Q',
    question: 'O chatbot sempre responde rapidamente?',
    idAns: 'chatBrandExp3',
    idVal: 'chatBrandExp3Val',
    qGlobId: 'chatExp',
    globId: 'cb',
  },
  // {
  //   idq: 'chatBrandExp4Q',
  //   question: "As respostas do chatbot foram sempre relevantes?",
  //   idAns: 'chatBrandExp4',
  //   idVal: 'chatBrandExp4Val',
  //   qGlobId: 'chatExp',
  //   globId: 'cb',
  // },
  {
    idq: 'chatBrandExp5Q',
    question: 'O chatbot sempre fornece as informações corretas?',
    idAns: 'chatBrandExp5',
    idVal: 'chatBrandExp5Val',
    qGlobId: 'chatExp',
    globId: 'cb',
  },
  // Patronage Intention
  {
    idq: 'chatPatrong1Q',
    question:
      'Você está disposto a fazer uma compra com a ajuda deste chatbot?',
    idAns: 'chatPatrong1',
    idVal: 'chatPatrong1Val',
    qGlobId: 'chatExp',
    globId: 'cb',
  },
  {
    idq: 'chatPatrong2Q',
    question: 'Qual é a probabilidade que você compre usando este chatbot?',
    idAns: 'chatPatrong2',
    idVal: 'chatPatrong2Val',
    qGlobId: 'chatExp',
    globId: 'cb',
  },
  {
    idq: 'chatPatrong3Q',
    question: 'Você recomendaria este chatbot a seus amigos e familiares?',
    idAns: 'chatPatrong3',
    idVal: 'chatPatrong3Val',
    qGlobId: 'chatExp',
    globId: 'cb',
  },
]
//// EXPORT CHATBOT CX RANDOMIZED /////////
export const chatExpPtg = flatten([...botCxIntPtg, randomize(chatExpPtgBef)])
//// END  BRQ RANDOMIZED /////////

/////////////// Ideal Variable Color Blue ///////////////
// Welcome Mesage
const colBluIntrPtg = [
  {
    id: 'colBlu',
    message: 'Cá, eu gostaria de saber o que você gosta sobre a cor azul! 💧',
    qGlobId: 'colBlu',
    globId: 'blu',
  },
]

const colBluePtgBef = [
  {
    idq: 'col1Blu',
    question: 'Você prefere o azul a outras cores',
    idAns: 'col1Blu',
    idVal: 'col1Blu',
    qGlobId: 'colBlu',
    globId: 'blu',
  },
  {
    idq: 'col2Blu',
    question: 'Você gosta da cor azul',
    idAns: 'col2Blu',
    idVal: 'col2Blu',
    qGlobId: 'colBlu',
    globId: 'blu',
  },
  {
    idq: 'col3Blu',
    question: 'Você gosta das roupas em azul',
    idAns: 'col3Blu',
    idVal: 'col3Blu',
    qGlobId: 'colBlu',
    globId: 'blu',
  },
  {
    idq: 'col4Blu',
    question: 'Você gosta da tinta azul',
    idAns: 'col4Blu',
    idVal: 'col4Blu',
    qGlobId: 'colBlu',
    globId: 'blu',
  },
]
//// EXPORT COLOR BLUE RANDOMIZED /////////
export const colBluPtg = flatten([...colBluIntrPtg, randomize(colBluePtgBef)])
//// END  COLOR BLUE /////////
